import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import { CustomButton, DatePicker } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';

import { getQuestionConfig } from '../../config/questionsConfig';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const questionConfig = getQuestionConfig(ProfilerQuestionID.MARRIAGE_ANNIVERSARY);


const Anniversary = ({
  questionId = ProfilerQuestionID.MARRIAGE_ANNIVERSARY,
  title = questionConfig?.question,
  subtitle =  questionConfig?.subtitle,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
}) => {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue ? dayjs(defaultValue) : null);
  const selectedValue = isControlled
    ? (typeof value === 'string' ? (value ? dayjs(value) : null) : value)
    : internalValue;

  // Keep dayjs in local state, but emit YYYY-MM-DD to parent.
  const handleChange = (newValue) => {
    if (!isControlled) {
      setInternalValue(newValue);
    }
    const dateString = newValue ? newValue.format('YYYY-MM-DD') : '';
    onChange?.(dateString);
  };
  const handleSubmit = () => {
    const formattedValue = selectedValue && selectedValue.isValid && selectedValue.isValid()
      ? selectedValue.format('YYYY-MM-DD')
      : '';

    onSubmit?.({
      question: [
        { id: questionId, value: formattedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          flex: 1,
          justifyContent: "space-between",
        }}>
        <CardHeader title={title} subtitle={subtitle} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component={"img"}
              src={PROFILER_IMAGES.ring}
              width={"150px"}></Box>
          </Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Date of Anniversary"
              type="date"
              value={selectedValue}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              placeholder="Select Date"
              selectableDate={dayjs()}
            />
          </LocalizationProvider>
        </Box>
        <CustomButton
          size="small"
          label={submitLabel}
          onClick={handleSubmit}
          disabled={
            !selectedValue || !selectedValue.isValid || !selectedValue.isValid()
          }
          sx={{ width: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default Anniversary;
